<template>
    <div v-on:keyup.tab="EventBus.$emit('TAB PRESSED')">
        <div class="header">
            <h1>Krājuma priekšmeti</h1>
            <div class="buttonsGroup">
              <form action="/dashboard/api/items" method="POST" class="d-inline">
                <input type="hidden" name="_token" :value="csrf">
                <input type="hidden" name="return_items_as_list" :value="true">
                <input type="hidden" name="internal_search" :value="filter_internal_search">
                <input type="hidden" name="cipher" :value="filter_cipher">
                <input type="hidden" name="item_number" :value="filter_item_number">
                <input type="hidden" name="item_subnumber" :value="filter_item_subnumber">
                <input type="hidden" name="act_number" :value="filter_act_number">
                <input type="hidden" name="title_old" :value="filter_title_old">
                <input type="hidden" name="collection_old" :value="filter_collection_old">
                <input type="hidden" name="transfer_type" :value="filter_transfer_type">
                <input type="hidden" name="acquire_from" :value="filter_acquire_from">
                <input type="hidden" name="author" :value="filter_author">
                <input type="hidden" name="location_of_manufacture" :value="filter_location_of_manufacture">
                <input type="hidden" name="time_of_manufacture" :value="filter_time_of_manufacture">
                <input type="hidden" name="content_date" :value="filter_content_date">
                <input type="hidden" name="size" :value="filter_size">
                <input type="hidden" name="material" :value="filter_material">
                <input type="hidden" name="placement" :value="filter_placement">
                <input type="hidden" name="description" :value="JSON.stringify(filter_description)">
                <input type="hidden" name="item_heading" :value="filter_item_heading">
                <input type="hidden" name="scientific_description" :value="JSON.stringify(filter_scientific_description)">
                <input type="hidden" name="internal_search" :value="filter_internal_search">
                <input type="hidden" name="images" :value="filter_images">
                <button class="btn btn-outline-primary" formtarget="_blank"><i class="fas fa-list"></i> Ģenerēt sarakstu</button>
              </form>
                <button class="btn btn-outline-primary"  data-toggle="modal" data-target="#detailed-search"><i class="fas fa-search"></i> Meklētājs</button>
            </div>
        </div>
        <div class="modal fade" tabindex="-1"  id="detailed-search" ref="vuemodal">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-primary text-white">
                        <h5 class="modal-title">Meklētājs</h5>
                        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="filter_search_type">Meklētāja veids</label>
                                    <select name="filter_search_type" id="filter_search_type" class="form-control" v-model="filter_search_type">
                                        <option value="detailed">Detalizētais meklētājs</option>
                                        <option value="universal">Universālais meklētājs</option>
                                    </select>
                                </div>
                                <hr>
                            </div>
                        </div>
                        <div class="row" v-if="filter_search_type=='universal'">
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="filter_internal_search">Meklē priekšmetu pēc visiem laukiem..</label>
                                    <tags-input element-id="internal_search"
                                                v-model="filter_internal_search"
                                                :typeahead="false"
                                                placeholder="rakstiet vārdus atdalot ar komatu"
                                                :add-tags-on-comma="true"
                                                :add-tags-on-blur="true"
                                    ></tags-input>
                                </div>
                            </div>
                        </div>
                        <div v-if="filter_search_type=='detailed'" class="row">
                            <div class="col-2">
                                <div class="form-group">
                                    <label for="filter_cipher">Šifrs</label>
                                    <input type="text" id="filter_cipher" v-model="filter_cipher" class="form-control">
                                </div>
                            </div>
                            <div class="col-2">
                                <div class="form-group">
                                    <label for="filter_item_number">Numurs</label>
                                    <input type="text" id="filter_item_number" v-model="filter_item_number" class="form-control">
                                </div>
                            </div>
                            <div class="col-2">
                                <div class="form-group">
                                    <label for="filter_item_subnumber">Apakšnumurs</label>
                                    <input type="text" id="filter_item_subnumber" v-model="filter_item_subnumber" class="form-control">
                                </div>
                            </div>
<!--                            <div class="col-2">-->
<!--                                <div class="form-group">-->
<!--                                    <label for="filter_photo_number">Foto numurs</label>-->
<!--                                    <input type="text" id="filter_photo_number" v-model="filter_photo_number" class="form-control">-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="col-2">-->
<!--                                <div class="form-group">-->
<!--                                    <label for="filter_item_count">Skaits</label>-->
<!--                                    <input type="text" id="filter_item_count" v-model="filter_item_count" class="form-control">-->
<!--                                </div>-->
<!--                            </div>-->
                            <div class="col-2">
                                <div class="form-group">
                                    <label for="filter_act_number">Akta numurs</label>
                                    <input type="text" id="filter_act_number" v-model="filter_act_number" class="form-control">
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label for="filter_title_old">Nosaukums</label>
                                    <input type="text" id="filter_title_old" v-model="filter_title_old" class="form-control">
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label for="filter_collection_old">Kolekcija</label>
                                    <input type="text" id="filter_collection_old" v-model="filter_collection_old" class="form-control">
                                </div>
                            </div>
                            <div class="col-6" v-if="hasPermission(user,'krajuma_darbinieks')">
                                <div class="form-group">
                                    <label for="filter_transfer_type">Ieguve</label>
                                    <input type="text" id="filter_transfer_type" v-model="filter_transfer_type" class="form-control">
                                </div>
                            </div>
                            <div class="col-6" v-if="hasPermission(user,'krajuma_darbinieks')">
                                <div class="form-group">
                                    <label for="filter_acquire_from">Nodevējs</label>
                                    <input type="text" id="filter_acquire_from" v-model="filter_acquire_from" class="form-control">
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label for="filter_author">Autors</label>
                                    <input type="text" id="filter_author" v-model="filter_author" class="form-control">
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label for="filter_location_of_manufacture">Izgatavošanas vieta</label>
                                    <input type="text" id="filter_location_of_manufacture" v-model="filter_location_of_manufacture" class="form-control">
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="filter_time_of_manufacture">Izgatavošanas laiks</label>
                                    <input type="text" id="filter_time_of_manufacture" v-model="filter_time_of_manufacture" class="form-control">
                                </div>
                            </div>
<!--                            <div class="col-6">-->
<!--                                <div class="form-group">-->
<!--                                    <label for="filter_content_date">Satura datējum3</label>-->
<!--                                    <input type="text" id="filter_content_date" v-model="filter_content_date" class="form-control">-->
<!--                                </div>-->
<!--                            </div>-->
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="filter_size">Izmērs</label>
                                    <input type="text" id="filter_size" v-model="filter_size" class="form-control">
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="filter_material">Materiāls</label>
                                    <input type="text" id="filter_material" v-model="filter_material" class="form-control">
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="filter_placement">Novietojums</label>
                                    <input type="text" id="filter_placement" v-model="filter_placement" class="form-control">
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="filter_item_heading">Priekšmeta virsraksts jeb nosaukums</label>
                                    <input type="text" id="filter_item_heading" v-model="filter_item_heading" class="form-control">
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="filter_description">Vārdi priekšmeta aprakstā</label>
                                    <tags-input element-id="filter_description"
                                                v-model="filter_description"
                                                :typeahead="false"
                                                placeholder="rakstiet vārdus atdalot ar komatu"
                                                :add-tags-on-comma="true"
                                                :add-tags-on-blur="true"
                                    ></tags-input>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="filter_scientific_description">Vārdi priekšmeta zinātniskajā aprakstā</label>
                                    <tags-input element-id="filter_description"
                                                v-model="filter_scientific_description"
                                                :typeahead="false"
                                                placeholder="rakstiet vārdus atdalot ar komatu"
                                                :add-tags-on-comma="true"
                                                :add-tags-on-blur="true"
                                    ></tags-input>
                                </div>
                            </div>
                            <div class="col-12">
                              <div class="form-group">
                                <label for="has_migration_list">Vai priekšmetam ir attēli?</label>
                                <select name="migration_status" id="migration_status" class="form-control" v-model="filter_images">
                                  <option value="">Rādīt visus</option>
                                  <option value="has_images">Tikai AR attēliem</option>
                                  <option value="has_not_images">Tikai BEZ attēliem</option>
                                </select>
                              </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-center">
                        <button class="btn btn-primary" v-if="loading ==false" @click="search()" key="search"><i class="fas fa-search"></i> Meklēt</button>
                        <button class="btn btn-primary" v-if="loading ==true" key="loading"><i class="fas fa-spinner fa-spin"></i> Meklē</button>
                        <button class="btn btn-primary" v-if="loading ==false"@click="clearFilters()" key="clear"><i class="fas fa-times"></i> Notīrīt filtrus</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="results">
            <div class="loader" v-if="loading">
                <img src="/images/loading.svg" alt="Loading">
            </div>
            <div class="alert alert-light text-left">
                Atrasto priekšmetu skaits - <strong>{{this.pagination.items_total_count}}</strong>.
            </div>
            <table class="table table-responsive-xl table-hover">
                <thead class="bg-primary text-white">
                <tr>
                    <th>Attēls</th>
                    <th>Numurs</th>
                    <th>Akts</th>
                    <th>Kolekcija</th>
                    <th>Nosaukums</th>
                    <th>Ieguve</th>
                    <th>Apraksts</th>
                    <th>Darbības</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in items" :key="item.id">
                    <td>
                            <img style="width:150px; height:auto" v-if="item.images.length>0" :src="'/public/image/thumb/'+item.images[0].file_name" alt="" title="">
<!--                        <img v-if="item.featured_image" :src="'/storage/items/'+item.id+'/images/generated/thumb/'+item.featured_image.file_name">-->
                    </td>
                    <td style="width:150px">{{item.cipher}} {{item.item_number}}<span v-if="item.item_subnumber">-{{item.item_subnumber}}</span></td>
                    <td><span v-if="item.act">{{item.act.act_number}}</span></td>
                    <td><span v-if="item.collection">{{item.collection.title}}</span></td>
                    <td><span v-if="item.title">{{item.title.title}}</span></td>
                    <td><span v-if="item.transfer_type">{{item.transfer_type.collection_title}}</span></td>
                    <td style="max-width:500px">{{item.description}}</td>
                    <td class="actions">

                        <item-edit-component
                            v-if="hasPermission(user,'krajuma_darbinieks')"
                            :key="'edit-component-'+item.id"
                            :transfer_types="transfer_types"
                            :item="item"
                            :item_titles="item_titles"
                            :item_collections ="item_collections "
                            :scientific_themes="scientific_themes"
                            :ciphers="ciphers"
                            :copyrights="copyrights"
                        ></item-edit-component>
                        <item-view-component
                            :key="'view-component-'+item.id"
                            :item="item"
                            :user="user"
                            :copyrights="copyrights"
                        ></item-view-component>
                    </td>
                </tr>
                </tbody>
            </table>
            <div class="pagination" v-if="pagination.show_pagination">
                <div class="pages">
                    <div class="page" @click="changePage(1)" v-if="pagination.show_first_page">1</div>
                    <div class="delimiter" v-if="pagination.show_first_page_divider">...</div>
                    <div class="page" @click="changePage(page)" v-for="page in pagination.prev_pages" :key="page">{{page}}</div>
                    <div class="page currentPage"  :key="pagination.current_page">{{pagination.current_page}}</div>
                    <div class="page" @click="changePage(page)" v-for="page in pagination.next_pages" :key="page">{{page}}</div>
                    <div class="delimiter" v-if="pagination.show_last_page_divider">...</div>
                    <div class="page" @click="changePage(pagination.total_page_count)" :key="pagination.total_page_count" v-if="pagination.show_last_page">{{pagination.total_page_count}}</div>
                </div>
            </div>
        </div>
        <Keypress key-event="keyup" :key-code="192" @success="showSearch()" />
    </div>
</template>

<script>
export default{
    props:['user','transfer_types','settings','item_titles','item_collections','scientific_themes','ciphers','copyrights'],
    components: {
        Keypress: () => import('vue-keypress')
    },
    mounted()
    {
        var that = this;
        EventBus.$on('open_next_item_edit_modal', (current_item_id) =>{
            that.openNextItemEditModal(current_item_id);
            that.item_view_modal_open = false;
            that.item_edit_modal_open = true;
            that.item_edit_last_button = 'next';
        });
        EventBus.$on('open_prev_item_edit_modal', (current_item_id) =>{
            that.openPrevItemEditModal(current_item_id);
            that.item_view_modal_open = false;
            that.item_edit_modal_open = true;
            that.item_edit_last_button = 'prev'
        });

        EventBus.$on('open_next_item_view_modal', (current_item_id) =>{
            that.openNextItemViewModal(current_item_id);
            that.item_edit_modal_open = false;
            that.item_view_modal_open = true;
            that.item_view_last_button = 'next';
        });
        EventBus.$on('open_prev_item_view_modal', (current_item_id) =>{
            that.openPrevItemViewModal(current_item_id);
            that.item_edit_modal_open = false;
            that.item_view_modal_open = true;
            that.item_view_last_button = 'prev'
        });

        setTimeout(() => {
            this.search();
        },500);

        EventBus.$on('items_updated',()=>
        {
            this.item_edit_modal_open=false;
            this.item_edit_last_button="";
            this.item_view_modal_open=false;
            this.item_view_last_button="";
            this.search(this.pagination.current_page);
        });

    },
    data()
    {
        return{
            items:[],
            pagination:[],
            loading:false,

            //Filtra vērtības
            filter_search_type:"detailed",
            filter_items_per_page:15,

            filter_cipher:"",
            filter_item_number:"",
            filter_item_subnumber:"",
            filter_photo_number:"",
            filter_item_count:"",
            filter_title_old:"",
            filter_collection_old:"",
            filter_transfer_type:"",
            filter_acquire_from:"",
            filter_author:"",
            filter_location_of_manufacture:"",
            filter_time_of_manufacture:"",
            filter_content_date:"",
            filter_size:"",
            filter_material:"",
            filter_placement:"",
            filter_act_number:"",
            filter_description:[],
            filter_item_heading:"",
            filter_scientific_description:[],
            filter_internal_search:[],
            filter_images:"",

            item_edit_modal_open:false,
            item_edit_last_button:"", //next or prev

            item_view_modal_open:false,
            item_view_last_button:"", //next or prev

            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        }
    },
    methods:{
        hasPermission(user,permission)
        {

            return user.allpermissions.some(function(p) {
                return p.name == permission;
            });
        },
        openPrevItemViewModal(item_id)
        {
            var index = this.items_list.findIndex(item => item === item_id)-1;
            if(index >= 0)
            {
                $('#view-'+this.items_list[index+1]).modal('hide');
                $('#view-'+this.items_list[index]).modal('show');
            }
            else {
                $('#view-'+this.items_list[index+1]).modal('hide');
                if(this.pagination.current_page - 1 >0)
                {
                    this.search(this.pagination.current_page-1);
                }

            }
        },
        openNextItemViewModal(item_id)
        {
            var index = this.items_list.findIndex(item => item === item_id)+1;
            if(index < this.items_list.length)
            {
                $('#view-'+this.items_list[index-1]).modal('hide');
                $('#view-'+this.items_list[index]).modal('show');
            }
            else{
                $('#view-'+this.items_list[index-1]).modal('hide');
                if(this.pagination.current_page+1 <= this.pagination.total_page_count)
                {
                    this.search(this.pagination.current_page+1);
                }

            }
        },


        openPrevItemEditModal(item_id)
        {
            var index = this.items_list.findIndex(item => item === item_id)-1;
            if(index >= 0)
            {
                $('#edit-'+this.items_list[index+1]).modal('hide');
                $('#edit-'+this.items_list[index]).modal('show');
            }
            else {
                $('#edit-'+this.items_list[index+1]).modal('hide');
                if(this.pagination.current_page - 1 >0)
                {
                    this.search(this.pagination.current_page-1);
                }

            }
        },
        openNextItemEditModal(item_id)
        {
            var index = this.items_list.findIndex(item => item === item_id)+1;
            if(index < this.items_list.length)
            {
                $('#edit-'+this.items_list[index-1]).modal('hide');
                $('#edit-'+this.items_list[index]).modal('show');
            }
            else{
                $('#edit-'+this.items_list[index-1]).modal('hide');
                if(this.pagination.current_page+1 <= this.pagination.total_page_count)
                {
                    this.search(this.pagination.current_page+1);
                }

            }
        },
        changePage(page)
        {
            this.item_view_modal_open = false;
            this.item_edit_modal_open = false;
            this.search(page);
        },
        clearFilters()
        {
            this.filter_items_per_page=15;

            this.filter_cipher="";
            this.filter_item_number="";
            this.filter_item_subnumber="";
            this.filter_photo_number="";

            this.filter_item_count="";
            this.filter_title_old="";
            this.filter_collection_old="";
            this.filter_transfer_type="";
            this.filter_acquire_from="";
            this.filter_author="";
            this.filter_location_of_manufacture="";
            this.filter_time_of_manufacture="";
            this.filter_content_date="";
            this.filter_size="";
            this.filter_material="";
            this.filter_placement="";
            this.filter_act_number="";
            this.filter_description=[];
            this.filter_item_heading="";
            this.filter_scientific_description=[];
            this.filter_internal_search=[];
            this.filter_images = "";

        },
        scrollToTop() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        showSearch()
        {
            $(this.$refs.vuemodal).modal('toggle');
        },
        normalDate(date)
        {
            var d = moment(date).format('DD.MM.YYYY.');
            if(moment(d, 'DD.MM.YYYY.').isValid()) {
                return d;
            }
            else {
                return null;
            }
        },
        search(page = 1)
        {
            var that = this;
            this.loading = true;
            if(this.filter_search_type == 'universal') {
                var filterData = {
                    internal_search: that.filter_internal_search,
                    page: page,
                    items_per_page: that.filter_items_per_page
                };
            }
            else{
                var filterData = {
                    cipher:that.filter_cipher,
                    item_number:that.filter_item_number,
                    item_subnumber:that.filter_item_subnumber,
                    photo_number: that.filter_photo_number,
                    item_count:that.filter_item_count,
                    title_old:that.filter_title_old,
                    collection_old:that.filter_collection_old,
                    transfer_type:that.filter_transfer_type,
                    acquire_from:that.filter_acquire_from,
                    author:that.filter_author,
                    location_of_manufacture:that.filter_location_of_manufacture,
                    time_of_manufacture:that.filter_time_of_manufacture,
                    content_date:that.filter_content_date,
                    size:that.filter_size,
                    material:that.filter_material,
                    placement:that.filter_placement,
                    act_number:that.filter_act_number,
                    description: that.filter_description,
                    item_heading: that.filter_item_heading,
                    scientific_description: that.filter_scientific_description,
                    images: that.filter_images,

                    page:page,
                    items_per_page: that.filter_items_per_page
                };
            }
            axios.post('/dashboard/api/items',filterData).then(response =>{
                that.loading = false;
                if (response.data.status == 'ok')
                {
                    that.loading = false;
                    that.scrollToTop();
                    that.items = response.data.items;
                    that.pagination = response.data.pagination;
                    EventBus.$emit('page_updated');
                    $(that.$refs.vuemodal).modal('hide');
                    if(that.item_edit_modal_open == true && that.item_edit_last_button == 'prev')
                    {
                        setTimeout(() => {
                                $('#edit-'+that.items_list[that.pagination.items_per_page -1]).modal('show');
                        },500);
                    }

                    if(that.item_edit_modal_open == true && that.item_edit_last_button == 'next')
                    {
                        setTimeout(() => {

                                $('#edit-'+that.items_list[0]).modal('show');

                        },500);
                    }

                    if(that.item_view_modal_open == true && that.item_view_last_button == 'prev')
                    {
                        setTimeout(() => {
                            $('#view-'+that.items_list[that.pagination.items_per_page -1]).modal('show');
                        },500);
                    }

                    if(that.item_view_modal_open == true && that.item_view_last_button == 'next')
                    {
                        setTimeout(() => {

                            $('#view-'+that.items_list[0]).modal('show');

                        },500);
                    }
                }
            })
        },
    },
    computed:{
        items_list()
        {
            var that = this;
            if(that.items)
            {
                return that.items.map(item =>{
                    return item.id;
                });

            }
        }

    }


}
</script>

<style lang="scss" scoped>
@use "sass:color";
@import '../../../sass/variables';
.actions{
    display:flex;
    align-items: center;
    justify-content: center;
    .edit{
        margin:0 5px;
    }
    .show{
        margin:0 5px;
    }
}
.header{
    display:flex;
    .buttonsGroup{
        margin-left:auto;
    }

}
.results{
    position:relative;
    .loader{
        cursor: progress;
        position:absolute;

        width:100%;
        height:100%;
        display:flex;
        align-items: center;
        justify-content: center;
        background:rgba(255,255,255,0.7);
        img{
            width:100px;
            height:100px;
        }

    }
}
.pagination{
    margin-top:20px;
    padding-top:20px;
    border-top:solid 2px #777;
    .pages{
        display:flex;
        margin:auto;
        .page{
            width:32px;
            height:32px;
            margin:0 10px;
            display:flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            border-radius:100%;
            font-weight: 700;
            transition: all .2s ease-in-out;
            &:hover{
                background:$blue;
                color:#fff;
            }
        }
        .delimiter{
            width:20px;
            height:32px;
            margin:0 0px;
            display:flex;
            color:#333;
            align-items: center;
            justify-content: center;
        }
        .currentPage{
            background:$blue;
            color:#fff;
            cursor:auto;
        }

    }
}
.documentFilter{
    display:flex;
    flex-wrap: wrap;
    padding:20px;
    box-shadow: 0px 1px 20px rgba(0, 0, 0, 0.2);
    margin-bottom:10px;

    .filterBtns{
        display:flex;
        align-items: center;
        justify-content: center;
        margin-top:10px;
        .btn{
            margin:5px;
        }
    }
    .filterItem{

        padding:5px 20px;
        flex-basis:300px;
        flex-grow:1;
    }
}
</style>
